import { render, staticRenderFns } from "./search-parking-sort.vue?vue&type=template&id=b1563300&scoped=true"
import script from "./search-parking-sort.vue?vue&type=script&lang=ts"
export * from "./search-parking-sort.vue?vue&type=script&lang=ts"
import style0 from "./search-parking-sort.vue?vue&type=style&index=0&id=b1563300&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1563300",
  null
  
)

export default component.exports